import React, { useEffect, useRef, useState } from "react";

const EmojiWrapper = React.memo(
  ({ handleEmoji, iconsSize = "large", chatView, message, cursorPositionRef, renderEmojiPickerDownward = false }) => {
  const [isEmojiPickerOpen, setIsEmojiPickerOpen] = useState(false);
  const emojiPickerContainerRef = useRef(null);
  const [emojiPickerData, setEmojiPickerData] = useState();
  const messageRef = useRef(message);

  useEffect(() => {
    messageRef.current = message;
  }, [message]);

  const icon = <div data-cy="emoji" className={`${iconsSize === "small" ? "hs-scale-0-8" : ""} actionIconsSprite emojiIcon`} />;
  useEffect(() => {
    if (isEmojiPickerOpen) {
      fetch("https://cdn.jsdelivr.net/npm/@emoji-mart/data") // This cdn could be replaced by hosting our own cdn
        .then((res) =>
          res.json().then(async (responseJson) => {
            setEmojiPickerData(responseJson);
          })
        );
    }
  }, [isEmojiPickerOpen]);

  const constructEmojiAndMessage = (emoji, event) => {
    const updatedMessage =
      messageRef.current?.slice(0, cursorPositionRef?.current) + emoji?.native + messageRef.current?.slice(cursorPositionRef?.current);
    cursorPositionRef.current = cursorPositionRef?.current + emoji?.native?.length;
    handleEmoji(updatedMessage, event, "emojis");
  };

  useEffect(() => {
    if (emojiPickerData) {
      createPicker();
    }
  }, [emojiPickerData]);

  const createPicker = () => {
    import("emoji-mart").then(
      ({ Picker }) =>
        new Picker({
          data: emojiPickerData,
          open: isEmojiPickerOpen,
          parent: emojiPickerContainerRef.current,
          theme: "light",
          onEmojiSelect: constructEmojiAndMessage,
          onClickOutside: () => setIsEmojiPickerOpen(false),
          perLine: chatView ? 6 : 9,
          previewPosition: "none",
          maxFrequentRows: 2,
        })
    );
  };

  const emojiPickerPositionClass = renderEmojiPickerDownward ? "top-0 hs-h-45" : "bottom-0";

  return (
    <>
      <div onClick={() => setIsEmojiPickerOpen((prev) => !prev)}>{icon}</div>
      {isEmojiPickerOpen && (
        <div className="position-absolute z-1">
          <div className={`position-absolute ${emojiPickerPositionClass} customSelectPopup`} ref={emojiPickerContainerRef} style={{  left: renderEmojiPickerDownward ? -60 : 0 }} />
        </div>
      )}
    </>
  );
});

export default EmojiWrapper;
